import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../constants/actionTypes";
import { logAPI } from "../api/andyliticsApi";

export default function* errorSaga() {
    yield takeLatest([types.APPLICATION_ERROR], handleAction);
}

function* handleAction(data) {
    switch (data.type) {
        case types.APPLICATION_ERROR:
            logAPI("MBHWeb.Saga.Error", new Date(), null, data);
            //yield put({type: types.APPLICATION_ERROR, error: data});  <-- uncomment here to start endless loop :)
            break;
    }
}